import React from "react";
import {connect, ConnectedProps} from "react-redux";
import {AuthGState, UntrademarkedLogin} from "@leap4/frontend";
import {RootState} from "../../../interfaces/root-state.interface";
import {BACKEND_SERVICE_NAME, requiredAuthRoles, setCookieUrl, meMultiUrl} from "../../../config/generals";
import {urlService} from "../../routing/urlsService";

const mapStateToProps = (state: RootState) => ({
    auth: state.auth,
});


const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface IProps extends PropsFromRedux {
    auth: AuthGState;
}


const LoginContainer = ({auth}: IProps) => {
    const redirectUrlForAuthenticated = urlService.home();

    const user = auth.user;
    return <UntrademarkedLogin {...{user, redirectUrlForAuthenticated, setCookieUrl}}
                  serviceName={BACKEND_SERVICE_NAME}
                  meUrl={meMultiUrl}
                  requiredRoles={requiredAuthRoles}
                  dashboardName={"X-Adv"}
                  loginUrl={"https://api.auth.adte-system.com/users/login"}

    />;
}


export default connector(LoginContainer)
